<template>
  <v-row>
    <v-col sm="12">
      <v-row class="justify-lg-space-between align-center">
        <v-card-title
          class="py-0 mb-12 mb-md-0 title font-weight-bold letter-spacing-normal"
        >
          Your Contribution
        </v-card-title>
      </v-row>
      <v-row class="justify-lg-space-between align-center">
        <v-col class="pa-0">
          <v-simple-table
            class="contribution-table border-radius-0 v-data-table-1 v-data-table-1--style3"
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Your Trip</th>
                  <th class="text-left">Recommended Contribution</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Group of {{ members }} ({{ days }})days</td>
                  <td class="notranslate">${{ total }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'Contribution',
  props: {
    members: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    days: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
